import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { PageError, PageHeader, PageLoading } from "@lumika/ui";
import { adminApi } from "../../api/admin";
import { BillingView, defaultBillingRange } from "../../components/BillingView";

/**
 * Per-dealership billing tab. Shows AI ledger × price book + Twilio
 * usage cache for a 30-day window.
 */
export function DealershipBillingPage() {
  const { dealershipId } = useParams();
  const range = defaultBillingRange();
  const q = useQuery({
    queryKey: ["admin", "billing", "dealership", dealershipId, range.start, range.end],
    queryFn: () => adminApi.dealershipBilling(dealershipId!, range),
    enabled: Boolean(dealershipId),
  });

  if (q.isLoading) return <PageLoading message="Loading billing…" />;
  if (q.isError) {
    return (
      <PageError
        title="Couldn't load billing"
        description="Try refreshing the page or narrowing the date range."
      />
    );
  }
  if (!q.data) return null;

  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        eyebrow="Billing"
        title="AI + Twilio usage"
        description={`Internal unit-economics view. Window: ${range.start} → ${range.end}.`}
      />
      <BillingView
        ai={q.data.ai}
        twilio={q.data.twilio}
        totals={q.data.combined}
        range={range}
      />
    </div>
  );
}
